<template>
	<div class="list">
		<header class="d-flex j-end a-center">
			<div class="tab d-flex j-center a-center" @click="$router.push('add')" style="margin-right: 2.25rem;">
				<div class="icon" style="width: 1rem;height: 1rem;margin-right: 0.63rem;"></div>
				<span>添加管理员</span>
			</div>
			<div class="search">
				<input type="text" v-model="search_input" placeholder="输入用户名">
				<div @click="admin_users_list" class="icon d-flex j-center a-center" style="cursor: pointer;">
					<i class="el-icon-search"></i>
				</div>
			</div>
		</header>
		<div class="table">
			<el-table :height="590" ref="multipleTable" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" label="">
				</el-table-column>
				<el-table-column align="center" label="用户名" width="140">
					<template slot-scope="scope">{{ scope.row.user_name }}</template>
				</el-table-column>
				<el-table-column align="center" prop="identity" label="职务" width="110">
				</el-table-column>
				<el-table-column align="center" prop="tel" label="联系电话" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="add_time" label="录入时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="last_login" label="最后登录时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="freez_login" label="暂停登陆" width="80" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-switch @change="openOrCloser(scope.row)" v-model="scope.row.is_login" active-color="#1E69FF" inactive-color="#B5CBF9">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="address" label="操作" width="240" show-overflow-tooltip>
					<template slot-scope="scope">
						<!-- <el-button size="mini"
							style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="openDetail(scope)">查看</el-button> -->
						<el-button size="mini"
							style="background: #FF9D1F;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<i class="el-icon-delete" style="margin-left: 10px;cursor: pointer;font-size: 1.3rem;"
							@click.stop="del_admin_users(scope.$index, scope.row)"></i>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<footer class="d-flex j-sb a-center">
			<div class="d-flex j-sb a-center">
				<div @click="delAll" class="button">删除</div>
				<div @click="save_allow_login(0)" class="button">开启</div>
				<div @click="save_allow_login(1)" class="button">关闭</div>
			</div>
			<el-pagination  @current-change="handleCurrentChange"
				:current-page.sync="currentPage" :page-size="10" layout="prev, pager, next, total" :total="total_records">
			</el-pagination>
		</footer>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				search_input: '',
				currentPage: 1, //初始页
				tableData: [],
				multipleSelection: [],
				total_records:0
			}
		},
		methods: {
			openDetail(e) {
				this.$router.push('edit')
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			handleEdit(index, row) {
				console.log(index, row);
				this.$router.push({path:'edit',query:row})
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.admin_users_list()
			},
			//管理员列表
			admin_users_list(){
				let params = {
					act:'admin_users_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:10,
					page:this.currentPage,
					keyword:this.search_input
				}
				this.$api.admin_users_list(params).then((res)=>{
					this.tableData = []
					this.total_records = parseInt(res.total_records)
					if(res.code == 0){
						res.data.forEach((item)=>{
							this.tableData.push({...item,is_login:item.is_login==1?false:true})
						})
					}
				})
			},
			//开启关闭
			openOrCloser(row){
				let params = {
					act:!row.is_login?'save_allow_login':'save_disable_login',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					admin_ids: row.user_id
				}
				this.$api.save_allow_login(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			//开启管理员登录功能
			save_allow_login(status){
				let ids = []
				if(!this.multipleSelection.length){
					return
				}
				this.multipleSelection.forEach((item)=>{
					this.tableData.forEach((v)=>{
						if(item.user_id == v.user_id){
							ids.push(v.user_id)
						}
					})
				})
				
				let params = {
					act:status?'save_allow_login':'save_disable_login',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					admin_ids: ids.join(',')
				}
				this.$api.save_allow_login(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
						this.admin_users_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
				
				
			},
			//单条删除
			del_admin_users(index,row){
				if(!row)return;
				let params = {
					act:'del_admin_users',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					admin_ids: row.user_id
				}
				this.$api.del_admin_users(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
						this.admin_users_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			//批量删除
			delAll(){
				if(!this.multipleSelection.length){
					return
				}
				let ids = []
				this.multipleSelection.forEach((item)=>{
					ids.push(item.user_id)
				})
				let params = {
					act:'del_admin_users',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					admin_ids: ids.join(',')
				}
				this.$api.del_admin_users(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
						this.admin_users_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			}
			
		},
		created() {
			this.admin_users_list()
		}
	}
</script>
<style lang="scss">
	.el-table thead {
		color: #000000 !important;
		font-size: 0.88rem;
	}

	// .el-table__header-wrapper {
	// 	.el-table_1_column_1 {
	// 		.cell {
	// 			visibility: hidden;
	// 		}
	// 	}
	// }
</style>
<style lang="scss" scoped>
	.list {
		max-width: 73.13rem;
		box-sizing: border-box;
		margin: 0 auto;
		padding: 0 0 3.63rem 0;

		header {
			height: 1.75rem;

			.active {
				background: #1A6BFF !important;
				color: #FFFFFF !important;
			}

			.tab {
				background: #FFFFFF;
				border: 2px solid #1E69FF;
				border-radius: 6px;
				font-size: 0.75rem;
				width: 7.5rem;
				text-align: center;
				height: 1.75rem;
				box-sizing: border-box;
				cursor: pointer;
				color: #1E69FF;

				&:hover {
					background: #1A6BFF;
					color: #FFFFFF;
					.icon{
						background: url(../../assets/itemStore/tjxz@2x.png);
						background-repeat: no-repeat;
						background-size: 100% 100%;
					}
				}
				.icon{
					background: url(../../assets/itemStore/tjmr@2x.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
			}

			.search {
				width: 16.9rem;
				height: 1.69rem;
				position: relative;

				input {
					font-size: 0.75rem;
					outline: none;
					border: 2px solid #1E69FF;
					border-radius: 4px;
					padding: 0 1.44rem;
					height: 100%;
					width: 100%;
					box-sizing: border-box;

					&::placeholder {
						font-size: .75rem;
					}
				}

				.icon {
					background: #1E69FF;
					height: 100%;
					padding: 0 0.38rem;
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
					border-radius: 0 4px 4px 0;

					i {
						color: #FFFFFF;
					}
				}


				&::-webkit-input-placeholder {
					color: #BBBBBB;
					font-size: 0.77rem;
				}
			}
		}

		.table {
			margin-top: 1.44rem;
			width: 100%;
			background: #FFFFFF;
			border-radius: 6px;
			overflow: hidden;
		}

		footer {
			width: 100%;
			height: 3.85rem;
			background: #FFFFFF;
			margin-top: 1.44rem;
			border-radius: 6px;
			padding: 0 1rem;
			box-sizing: border-box;

			.button {
				width: 5.63rem;
				height: 1.25rem;
				color: #000000;
				display: flex;
				justify-content: center;
				align-items: center;
				border: 1px solid #000000;
				border-radius: 0.625rem;
				font-size: 0.75rem;
				margin: 0 1.1rem;
				cursor: pointer;
				box-sizing: border-box;
				&:hover{
					border: 2px solid #000000;
					font-weight: bold;
				}
			}
		}
	}
</style>
